import React from 'react';
import { useDropzone } from 'react-dropzone';
import { useApplication } from '../../model/context/applicationContext';
import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import FileUploadIcon from '@mui/icons-material/FileUpload';

const DragDropFile = () => {
  const { setApplication, applicationSource, applicationXmlFilename } = useApplication();
  const intl = useIntl();
  const { getRootProps, getInputProps } = useDropzone({
    accept: '.xml',
    onDrop: (acceptedFiles: File[]) => {
      const file = acceptedFiles[0];
      const fileName = file?.name;
      const reader = new FileReader();

      reader.onload = (e) => {
        const fileText = e.target?.result as string;
        const parser = new DOMParser();
        const fileXml = parser.parseFromString(fileText, 'application/xml');
        const applicationNumber = fileXml.querySelector('ApplicationNumber')?.textContent;

        if (applicationNumber) {
          setApplication(applicationNumber, 'Local', { name: fileName, xml: fileText });
        }
      };
      reader.readAsText(file);
    }
  });

  const usePalette = useTheme().palette;
  const theme = useTheme();
  const baseStyle: React.CSSProperties = {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    padding: '15px',
    borderColor: usePalette.grey[400],
    cursor: 'pointer',
    borderStyle: 'dashed',
    borderWidth: '2.5px',
    color: usePalette.grey[700],
    borderRadius: '8px',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    flexDirection: 'column',
    justifyContent: 'center',
    textAlign: 'center'
  };

  return (
    <Box
      {...getRootProps()}
      sx={{
        ...baseStyle,
        '&:hover': {
          color: '#000',
          borderColor: '#000'
        }
      }}>
      <input {...getInputProps()} />
      <FileUploadIcon sx={{ mb: 1 }} />
      <Typography fontWeight={theme.typography.fontWeightLight}>
        {intl.formatMessage({ id: 'DropXmlFile' })}
      </Typography>
      <Typography variant={'body2'}>{intl.formatMessage({ id: 'ClickToUpLoad' })}</Typography>
      {applicationSource === 'Local' && (
        <Typography variant={'body2'} sx={{ mt: 1, color: '#000' }}>
          <span>File:</span> '<span style={{ fontWeight: 700 }}>{applicationXmlFilename}</span>'
        </Typography>
      )}
    </Box>
  );
};

export default DragDropFile;
